export default function () {
  return {
    getItem: (item: string) => {
      if (process.client) {
        const storageItem = sessionStorage.getItem(item)
        return storageItem ? JSON.parse(storageItem) : undefined
      } else {
        return undefined
      }
    },
    setItem: (key: string, value: unknown) => {
      if (process.client) {
        return sessionStorage.setItem(key, JSON.stringify(value))
      } else {
        return undefined
      }
    },
    removeItem: (key: string) => {
      if (process.client) {
        return sessionStorage.removeItem(key)
      } else {
        return undefined
      }
    },
  }
}
